import React from 'react';

import { Box, Checkbox, HStack, Stack } from '@chakra-ui/react';
import { customTheme } from 'theme';

import { radioBoxStyles } from 'containers/Setup/CloudAccounts/CloudAccountWizard/styles';

export const FormConfirmationField = ({
  header,
  subHeader,
  onClick,
  isChecked,
  isDisabled = false,
}) => {
  return (
    <Box {...radioBoxStyles}>
      <Stack
        spacing={0}
        onClick={() => !isDisabled && onClick()}
        cursor={isDisabled ? 'not-allowed' : 'pointer'}
        opacity={isDisabled ? 0.5 : 1}
      >
        <HStack>
          <Checkbox isChecked={isChecked} isDisabled={isDisabled} size="lg" />
          <Box color={isDisabled ? customTheme.colors.gray['250'] : 'primary'}>
            {header}
          </Box>
        </HStack>
        <Box fontSize="sm" color={customTheme.colors.gray[250]} pl={7}>
          {subHeader}
        </Box>
      </Stack>
    </Box>
  );
};
